import PackageModifier from "../components/PackageModifier";
import useModalForm from "../../../@hooks/useModalForm";
import service from "../../../@services";
export default function useAddPackage() {
  const { open } = useModalForm(PackageModifier);
  const addPackage = (packageUnit={}) => {
    return new Promise((resolve,reject)=>{
      open(
        async (data) => {
          const res = await packageUnit.id
          ? service.package.updatePackage(data)
          : service.package.createPackage(data);
          return res.then((packageId)=>{
            resolve(packageId)
          }).catch((e) => {
            reject(e)
            throw e
          })
        },
        packageUnit,
        {
          title: packageUnit.id?"编辑包装单位":"新增包装单位",
        }
      );
    })
  };
  return {
    addPackage,
  };
}